<template>
  <div>
    <div class="form-container ou-donation-form">
      <div class="holder">

        <PaymentForm class="form-horizontal">
          <FormSection title="Donation Amount">
            <div>
              <AmountSelector />
              <ErrorLabel field="amount" />
            </div>
            <br />
            <InHonorOf />
          </FormSection>
          <FormSection v-if="form.amount">
            <TransactionFee />
          </FormSection>
          <FormSection title="Personal Information">
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
              <Consent privacy="https://www.ou.org/privacy-policy/"/>
            </FormRow>
          </FormSection>

          <FormSection title="Billing Information">
            <DonorAddress />
          </FormSection>
          <FormRow>
            <NewsletterSubscribe
              text="Sign up to keep up to date with our fight against antisemitism, extremism and hate, and learn how you can make a difference."
            />
          </FormRow>
          <FormRow>
              <input
                type="checkbox"
                id="planningSpecialist"
                name="planningSpecialist"
                @click="setValue('custom.planningSpecialist', $event.target.checked)"
              />
              <FormLabel for="planningSpecialist">
                Please have the OU’s Legacy Planning Specialist reach out to me</FormLabel
              >
            </FormRow>
          <FormSection title="Payment Information" last>
            <FormRow>
              <Receipt />
            </FormRow>               
            <FormRow inline>
              <FormCol field="card" :showLabel="false" />
            </FormRow>
          </FormSection>
  
          <PaymentButton showAmount btnText="Confirm and Donate "/>
        </PaymentForm>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  computed,
  defineComponent,
  onMounted,
  ref,
  watch,
} from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";
import { queryParams } from "~/shared/query-params";



export default defineComponent({
  props: {
    subCampaign: String,
  },
  setup(props) {
    const { form, submit, setValue } = usePaymentForm();
    return {
      form,
      setValue,
      submit,
    };
  },
});
</script>
<style scoped lang="scss">
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
::v-deep h2 {
    font-style: normal;
    font-weight: 700 !important;
    font-size: 16px !important;
    margin-bottom: 16px !important;
    line-height: 24px !important;
    color: #080f16 !important;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}

::v-deep.styled-radio-container.styled-radio-container--ou-donation.row {

  margin: 0 0 5px 0px;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  gap: 16px;

  label {
    cursor: pointer;
    height: 100%;
    width: 100%;
    padding: 32px 46px;
    border-radius: 8px;
border: 2px solid  #EEEFF0;
background: #FFF;
    &:hover {
      background: #fafafa;
    }
    @media only screen and (max-width: 500px) {
      padding: 10px 14px;
    }
  }
  input {
    height: 0;
    top: 20px;
    position: absolute;
    left: 20px;
    z-index: -1;
    visibility: hidden;
  }
  .money_format{
    color: #1F262E;
text-align: center;
font-size: 24px;
font-style: normal;
padding-bottom: 10px;
font-weight: 700;
line-height: 24px; 
text-transform: capitalize;
  }
    .label-description {
    color: #9FA4AA;
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px;
    }
  input[type="radio"]:checked + label {
    border: 2px solid #1e50b4;
    .money_format {
      color: #1e50b4;
    }
    .label-description {
      color: #080f16;
    }
  }
}
::v-deep .form-container.ou-donation-form {
  margin: 0px auto !important;
    padding: 0px !important;
    border-radius: 0px !important;
    max-width: 100% !important;
    border: none !important;
    box-shadow: none;
}

::v-deepbutton#donate-widget-form-submit{
  background: #E56C15;
  border-color: #E56C15;
&:hover{
      background: #C25100;
}
}



.radio-container {
  display: flex;
  gap: 10px;
  align-items: center;
  padding-bottom: 5px;
}


.monthly-note {
  font-size: 13px;
  line-height: 1.4;
  margin-top: 10px;
  display: flex;
  align-items: center;

  .month-limit {
    margin-right: 20px;
    min-width: 110px;
  }
}

input#swag_yes, input#swag_no {
    position: relative;
    margin: 0px 0px 0px;
}

::v-deep span.flex > span {
    display: flex;
}
</style>
